var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 22.9999H27V11.4374C27.0007 11.1586 26.942 10.8828 26.8277 10.6285C26.7135 10.3742 26.5464 10.1471 26.3375 9.9624L16.3375 0.874898C15.9709 0.538467 15.4914 0.351807 14.9937 0.351807C14.4961 0.351807 14.0166 0.538467 13.65 0.874898L3.65 9.9624C3.44526 10.1497 3.28173 10.3776 3.16983 10.6315C3.05792 10.8855 3.00009 11.1599 3 11.4374V22.9999H1C0.734784 22.9999 0.48043 23.1053 0.292893 23.2928C0.105357 23.4803 0 23.7347 0 23.9999C0 24.2651 0.105357 24.5195 0.292893 24.707C0.48043 24.8945 0.734784 24.9999 1 24.9999H29C29.2652 24.9999 29.5196 24.8945 29.7071 24.707C29.8946 24.5195 30 24.2651 30 23.9999C30 23.7347 29.8946 23.4803 29.7071 23.2928C29.5196 23.1053 29.2652 22.9999 29 22.9999ZM18 22.9999H12V16.9999C12 16.7347 12.1054 16.4803 12.2929 16.2928C12.4804 16.1053 12.7348 15.9999 13 15.9999H17C17.2652 15.9999 17.5196 16.1053 17.7071 16.2928C17.8946 16.4803 18 16.7347 18 16.9999V22.9999Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ff4304cb.svg";
export { ForwardRef as ReactComponent };